module.exports = __webpack_public_path__ + "media/images/responsive/page_common/noimage/landscape/text_black-1287620dc825c471fd6d007faf121750.png";